// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hvxb0fLSZvjNFZd4uEqf {
  margin-bottom: 2.5rem;
}

.sRZScUk5QJ091JYjWgJZ {
  color: var(--white);
  margin-bottom: 1.5rem;
}

.GWyFSCEyVJ2mxLxfI74a {
  display: flex;
  flex-direction: column;
}

.lHGEKSeyBV3TV8YcfCqS {
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  color: var(--footer-link-color);
}

.lHGEKSeyBV3TV8YcfCqS:hover {
  color: var(--footer-link-color);
}

@media only screen and
  (max-width: 639px) {
  .lHGEKSeyBV3TV8YcfCqS {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterLinksSection/FooterLinksSection.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAe;EACf,qBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  margin-bottom: 40px;\n}\n\n.title {\n  color: var(--white);\n  margin-bottom: 24px;\n}\n\n.links {\n  display: flex;\n  flex-direction: column;\n}\n\n.link {\n  font-size: 18px;\n  margin-bottom: 8px;\n  color: var(--footer-link-color);\n}\n\n.link:hover {\n  color: var(--footer-link-color);\n}\n\n@media (--mobile) {\n  .link {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `hvxb0fLSZvjNFZd4uEqf`,
	"title": `sRZScUk5QJ091JYjWgJZ`,
	"links": `GWyFSCEyVJ2mxLxfI74a`,
	"link": `lHGEKSeyBV3TV8YcfCqS`
};
export default ___CSS_LOADER_EXPORT___;
